(function () {
  var STORAGE_KEY = 'peshni_wishlist';

  function getWishlist() {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
    } catch (e) {
      return [];
    }
  }

  function setWishlist(ids) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(ids));
  }

  function refreshButton(button) {
    var id = button.getAttribute('data-product-id');
    var active = getWishlist().indexOf(id) !== -1;
    button.classList.toggle('is-active', active);
    button.setAttribute('aria-pressed', active ? 'true' : 'false');
    button.setAttribute('aria-label', active ? 'Remove from wishlist' : 'Add to wishlist');
  }

  function refreshAllButtons() {
    document.querySelectorAll('[data-peshni-wishlist-toggle]').forEach(refreshButton);
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-peshni-wishlist-toggle]');
    if (!button) return;

    var id = button.getAttribute('data-product-id');
    var wishlist = getWishlist();
    var index = wishlist.indexOf(id);

    if (index === -1) {
      wishlist.push(id);
    } else {
      wishlist.splice(index, 1);
    }

    setWishlist(wishlist);
    refreshAllButtons();
  });

  document.addEventListener('DOMContentLoaded', refreshAllButtons);
  if (document.readyState !== 'loading') refreshAllButtons();
})();
